module.exports = __webpack_public_path__ + "static/out.4efe8b3a.svg";